import { apiClient } from "./client";
import { Settings, SettingsUpdate } from "../types";

export const settingsApi = {
  getSettings: async (): Promise<Settings> => {
    const response = await apiClient.get<Settings>("/settings/");
    return response.data;
  },

  updateSettings: async (update: SettingsUpdate): Promise<Settings> => {
    const response = await apiClient.put<Settings>("/settings/", update);
    return response.data;
  },
};
